import { useEffect, useState } from "react";
import { _Labour, _LabourType, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { SelectLabourTimeConstants } from "./SelectLabourTimeConstants";
import { SelectLabourType } from "../../LabourType/SelectLabourType";
import { toast } from "react-toastify";
import { SelectProductionResource } from "../../ProductionResource/SelectProductionResource";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { SelectRecurso } from "../../LabourType/SelectRecurso";
import useModal, { MODAL_md } from "../../../theme/Component/hooks/useModal";
import { ImportXLSX } from "../../../theme/Component/ImportXLSX";
import { CostingCenterSelect } from "../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { ResourceResourceCostCatalog } from "./ResourceResourceCostCatalog/ResourceResourceCostCatalog";


interface Props {
    IDProductionRoute: number;
}

export const Labour = ({ IDProductionRoute }: Props) => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_Labour);
    const [costoperation, setcostoperation] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        getLista()
    }, [IDProductionRoute])

    const getLista = () => {
        instance.getLabourCatalog(IDProductionRoute).then(
            (rta: any) => {
                const sortedList = rta.sort((a, b) => a.DataBeanProperties.IDLabour - b.DataBeanProperties.IDLabour);
                setLista(sortedList);
            }
        ).catch(
            err => { console.log(err) }
        )
    }


    const editaItem = () => {
        const x = bean;
        x.IDEmployee = _single.getAccountID();
        instance.updateLabour(x).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDLabour).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLabour', visible: true },
        { title: 'Orden de Labor', property: 'LabourOrder', visible: true },
        { title: 'Tipo de Actividad', property: 'LabourTypeName', visible: true },
        { title: 'Recurso', property: 'ProductionResourceName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },

        { title: 'Centro de Costo', property: 'CostingCenterStr', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Unidades', property: 'LabourTimeUnitName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true, mask: MASK_MONEY },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            IDProductionRoute: IDProductionRoute,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Labores/Tareas a Ejecutar" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Importar', visible: _single.canCreate(), icono: 'ri-file-excel-line', evento: () => { modalImport.open(); } }

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Costos de la Tarea/Operación', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setcostoperation({ ...costoperation, "view": true, "name": "Costos de la Tarea/Operación" }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Labores/Tareas a Ejecutar" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Labores/Tareas a Ejecutar` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "IDLabourType", "LabourTimeUnit", "Quantity", "UnitaryCost",
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };


    const modalImport = useModal("Importar", MODAL_md);
    const [listImport, setListImport] = useState([]);

    const importMenu = async () => {
        console.log(listImport);
        let existe: string[] = [];
        let errores: number[] = [];

        lista.forEach(element => {
            existe.push(element.DataBeanProperties.Name.trim());
        });

        for (let index = 1; index < listImport.length; index++) {
            let row = listImport[index];

            console.log(row);

            if (!existe.includes(row[0])) {
                let obj = {
                    Name: row[0],
                    IDLabourType: row[1],
                    IDProductionResource: row[2],
                    Description: row[3],
                    LabourTimeUnit: row[4],
                    Quantity: row[5],
                    UnitaryCost: row[6],
                    IDEmployee: _single.getAccountID(),
                    IDProductionRoute: IDProductionRoute,
                };

                try {
                    await instance.updateLabour(obj).then(
                        (resp) => {
                            toast.success(`Item creado en la fila ${index + 1}`)
                        }
                    ).catch
                        (
                            err => {
                                console.log(`Error en la fila ${index}:`, err);
                                errores.push(index);
                            }
                        )

                } catch (err) {
                    toast.error(`Error al crear el item en la fila ${index}`);
                    errores.push(index);
                }
            }
        }

        // fin del proceso

        await getLista();

        setModal({ ...modal, "view": false });
        modalImport.close();
        if (errores.length > 0) {
            alert(`Error en los siguientes índices: ${errores.join(", ")}`);
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} />
            </div>


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDLabour} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDLabourType') ? 'has-error' : ''}`}>Tipo de Actividad</label>
                            <SelectLabourType render={bean.LabourTypeName} idSelector={bean.IDLabourType} onChange={(e) => { setBean({ ...bean, "IDLabourType": e.IDLabourType, "LabourTypeName": e.Name }) }} label=" " returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <label >Recurso</label>
                            <SelectRecurso render={bean.ProductionResourceName} idSelector={bean.IDProductionResource} onChange={(e) => { setBean({ ...bean, "IDProductionResource": e.IDProductionResource, "ProductionResourceName": e.Name }) }} label=" " returnType="Object" />
                            {/* <label className={`${missingFields.includes('IDLabourType') ? 'has-error' : ''}`}>Tipo de Actividad</label> */}
                            {/* <SelectProductionResource idSelector={bean.IDProductionResource} onChange={(e) => { setBean({ ...bean, "IDProductionResource": e }); console.log(e) }} label="Recurso" /> */}
                        </div>
                        <div className="col-md-12">
                            <label>Descrición</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('LabourTimeUnit') ? 'has-error' : ''}`}>Unidades</label>
                            <SelectLabourTimeConstants label=" " idSelector={bean.LabourTimeUnit} onChange={(e) => { setBean({ ...bean, "LabourTimeUnit": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                            <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UnitaryCost') ? 'has-error' : ''}`}>Costo Unitario</label>
                            {/* <InputMoney _value={bean.UnitaryCost} onChange={(e) => { setBean({ ...bean, "UnitaryCost": e }) }} _label=" " /> */}
                            <input type="number" name="UnitaryCost" className="form-control" value={bean.UnitaryCost} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Centro de Costo</label>
                            <CostingCenterSelect fKey="Code" idSelector={bean.CostingCenterStr} onChange={(e) => { setBean({ ...bean, "CostingCenterStr": e }) }} label=" " />
                        </div>
                        {/* <PrintJson json={bean} /> */}
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <Modal modal={costoperation} updateModal={setcostoperation}>
                    <>
                        <ResourceResourceCostCatalog idLabour={bean.IDLabour} />
                    </>
                </Modal>
            </div>
            <div className="col-md-12">

                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={importMenu} onSubmitLabel="Importar">
                    <div className="row">
                        <div className="col">
                            <ImportXLSX lodaData={setListImport} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div >
    )
}



